const COMMENTS = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20woman%2C%20studio%20lighting%2C%20neutral%20background%2C%20warm%20tone&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜小能手',
    time: '2小时前',
    content: '17吃瓜网真的太顶了！每天上班第一件事就是打开网页看今天有什么新瓜，更新速度比微博还快，内容也很靠谱，不是那种标题党。推荐给同事了！',
    tag: '忠实用户',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20man%2C%20studio%20lighting%2C%20neutral%20background%2C%20warm%20tone&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '娱乐圈观察员',
    time: '5小时前',
    content: '从贴吧时代就开始吃瓜了，17吃瓜网是目前做得最专业的吃瓜平台。分类清晰、更新及时，APP端体验也很流畅。希望继续保持这个水准！',
    tag: '资深瓜友',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20woman%20in%20her%2030s%2C%20studio%20lighting%2C%20neutral%20background%2C%20warm%20tone&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '八卦早知道',
    time: '8小时前',
    content: '说实话现在网络上假消息太多了，但17吃瓜网每条爆料都有截图和证据，让人看得放心。最近那个顶流网红翻车的系列报道，全程追完，太刺激了！',
    tag: '认证用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            用户评价
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            瓜友热评
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {COMMENTS.map((c) => (
            <div
              key={c.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 flex flex-col gap-4 hover:border-primary-200/60 transition-colors duration-200"
            >
              <div className="flex items-center gap-3">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  width="40"
                  height="40"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-900">{c.name}</span>
                    <span className="text-[10px] px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
                      {c.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{c.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{c.content}</p>
              <div className="flex items-center gap-1 text-accent-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}